import React, { useState, useEffect, useRef } from "react";
import "./MathKeyboardModal.css";
import MathKeyboardInput from "./MathKeyboardinput";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { MathNode } from "../../pages/home/components/dashboard/teacher/lessons/MathNode";
import { $createParagraphNode, $createTextNode, $getRoot, $getSelection, $isRangeSelection } from "lexical";
import { toast } from "react-toastify";

const MathKeyboardModal = ({ isOpen, onClose, onInsert, latextextvalue, assignmentType }) => {
  const [editor] = useLexicalComposerContext();
  const [latex, setLatex] = useState("");
  const mathInputRef = useRef(null);
  const mathFieldRef = useRef(null);
  const keyboardVisibleRef = useRef(false);
  const replaceLatex = latex.replace(/^(\$+)|(\$+)$/g, "");
  const cleanedLatex = replaceLatex.trim().replace(/(\\;|\\\\|\\,|\\quad|\\!|\s)/g, "");
  const isMeaningfulLatex = cleanedLatex.length > 0;

  useEffect(() => {

    if (latextextvalue === null) {
      setLatex('')
    } else {
      setLatex(latextextvalue);
    }
  }, [latextextvalue])


  useEffect(() => {
    return () => {
      if (keyboardVisibleRef.current) {
        try {
          const mathField = mathFieldRef.current;
          if (mathField) {
            if (document.activeElement === mathField) {
              document.body.focus();
            }
          }
        } catch (e) {
        }
      }
    };
  }, []);



  const getMathField = () => {
    if (!mathInputRef.current) return null;

    const mathField = mathInputRef.current.querySelector("math-field");

    if (mathField) {
      mathFieldRef.current = mathField;
    }

    return mathField;
  };

  const showKeyboard = () => {
    const mathField = mathFieldRef.current || getMathField();
    if (!mathField) return;

    try {
      mathField.executeCommand("virtual-keyboard", "show");
      keyboardVisibleRef.current = true;
    } catch (e) {
      try {
        mathField.executeCommand("showVirtualKeyboard");
        keyboardVisibleRef.current = true;
      } catch (e2) {
        try {
          mathField.executeCommand("virtual-keyboard", "toggle");
          keyboardVisibleRef.current = true;
        } catch (e3) {
        }
      }
    }

    setTimeout(() => {
      if (mathField && document.contains(mathField)) {
        mathField.focus();
      }
    }, 50);
  };

const hideKeyboard = () => {
  try {
    if (window.mathVirtualKeyboard) {
      window.mathVirtualKeyboard.hide();
    }
  } catch (e) {}

  const mathField = mathFieldRef.current || getMathField();
  if (mathField && document.activeElement === mathField) {
    try { document.body.focus(); } catch (e) {}
  }

  keyboardVisibleRef.current = false;
};

  useEffect(() => {
    if (!isOpen) {
      if (keyboardVisibleRef.current) {
        hideKeyboard();
      }

      setLatex("");
    } else {
      const timer = setTimeout(() => {
        getMathField();
        showKeyboard();
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [isOpen]);




  const handleChange = (event) => {
    const value = event.target.value;
    if (value.startsWith("$$") && value.endsWith("$$")) {
      setLatex(value.slice(2, -2));
    } else if (value.startsWith("$") && value.endsWith("$")) {
      setLatex(value.slice(1, -1));
    } else {
      setLatex(value);
    }
  };

 const handleDelete = () => {
  hideKeyboard();                        // ← hide first
  keyboardVisibleRef.current = false;   // ← then mark false

  if (
    isOpen &&
    mathFieldRef.current &&
    document.contains(mathFieldRef.current)
  ) {
    try {
      if (document.activeElement === mathFieldRef.current) {
        document.body.focus();
      }
    } catch (e) {}
  }
  onInsert("delete");
  onClose();
  setLatex("");
};


const handleInsert = () => {
  hideKeyboard();                        // ← hide first
  keyboardVisibleRef.current = false;   // ← then mark false

  if (
    isOpen &&
    mathFieldRef.current &&
    document.contains(mathFieldRef.current)
  ) {
    try {
      if (document.activeElement === mathFieldRef.current) {
        document.body.focus();
      }
    } catch (e) {}
  }

  const valueToInsert = latex.startsWith("$$") ? latex : `$$${latex}$$`;

  if (valueToInsert.match(/\\placeholder\{\}/g)) {
    toast.error('Kindly fill in all fields or remove empty box.');
    return;
  }

  onInsert(valueToInsert);
  onClose();
  setLatex("");
};

const handleClose = () => {
  // ← WRONG ORDER: was setting false before hiding
  // keyboardVisibleRef.current = false;  
  
  hideKeyboard(); // ← hide first (uses the ref internally)
  keyboardVisibleRef.current = false; // ← then mark as hidden
  onClose();
  setLatex("");
};

  return (
    isOpen && (
      <div className="modal-backdrop">
        <div className="modal-content">
          <div className="modal-header">
            <h3>Mathematical Keyboard</h3>
          </div>

          <div style={{ width: "100%", minHeight: "80px" }}>
            <div ref={mathInputRef}>
              <MathKeyboardInput
                value={!latex ? "" : latex.startsWith("$") ? latex : `$$${latex}$$`}
                onChange={handleChange}
                assignmentType={assignmentType}
              />
            </div>
          </div>

          <div
            className="modal-footer"
            style={{ display: "flex", justifyContent: "flex-end", gap: "9px" }}
          >
            <button onClick={handleClose} className="cancel-button">
              Cancel
            </button>
            <button onClick={handleDelete} className="insert-button" style={{ backgroundColor: 'red', display: latextextvalue === null && 'none' }} >
              Delete
            </button>
            <button onClick={handleInsert} className="insert-button" style={{ backgroundColor: !isMeaningfulLatex && 'grey' }} disabled={!isMeaningfulLatex}>
              Insert
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default MathKeyboardModal;